import { createContext, useState } from 'react';

export const DownloadContext = createContext({
  downloads: [],
  addDownload: () => {},
  updateDownloadProgress: () => {},
  removeDownload: () => {},
  cancelDownload: () => {},
});

export const DownloadProvider = ({ children }) => {
  const [downloads, setDownloads] = useState([]);

  const addDownload = (id, fileName, cancelToken) => {
    setDownloads((prev) => [...prev, { id, fileName, progress: 0, cancelToken }]);
  };
  
  const cancelDownload = (id) => {
    setDownloads((prev) => {
      const download = prev.find((d) => d.id === id);
      if (download?.cancelToken) {
        download.cancelToken.cancel("Download cancelled by user.");
      }
      return prev.filter((d) => d.id !== id);
    });
  };
  

  const updateDownloadProgress = (id, progress) => {
    setDownloads((prev) =>
      prev.map((download) =>
        download.id === id ? { ...download, progress } : download
      )
    );
  };

  const removeDownload = (id) => {
    setDownloads((prev) => prev.filter((download) => download.id !== id));
  };

  return (
    <DownloadContext.Provider
      value={{ downloads, addDownload, updateDownloadProgress, removeDownload,cancelDownload, }}
    >
      {children}
    </DownloadContext.Provider>
  );
};
